import { render, staticRenderFns } from "./FilterBarProvider.vue?vue&type=template&id=4c5ca46f&scoped=true"
import script from "./FilterBarProvider.vue?vue&type=script&setup=true&lang=ts"
export * from "./FilterBarProvider.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FilterBarProvider.vue?vue&type=style&index=0&id=4c5ca46f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ca46f",
  null
  
)

export default component.exports